import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyC3lfSzfqlwhoqAWHZH15w64c7H2kr7v74",
  authDomain: "ooh-gpt.firebaseapp.com",
  databaseURL: "https://ooh-gpt-default-rtdb.firebaseio.com",
  projectId: "ooh-gpt",
  storageBucket: "ooh-gpt.appspot.com",
  messagingSenderId: "831291528861",
  appId: "1:831291528861:web:8e32b6a6c0f48c33e42674",
  measurementId: "G-9VQ7TXVPV9"
};

const app = initializeApp(firebaseConfig);

export {app}